import React, { useContext, useEffect, useState } from 'react';
import { Sidebar } from 'semantic-ui-react';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { gEnums } from '../../enums/globalEnums';
import _ from 'lodash';
import FullPageWrapper from 'global/wrappers/FullPageWrapper';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import { useStyles } from 'global/cnr/contexts/useHelpers/useStyles';

const DataSidebar = (props) => {

  const { visible, content, onHide, direction, width, cn } = props;

  const { setStyleAndClass } = useStyles()

  const styleAndClass = setStyleAndClass({ item: gEnums.projectStyles.actionItems })

  if (styleAndClass) {
    styleAndClass.className = direction === 'left' ? 'sbl' : 'sbr';
  }

  // --- internal state to prevent immediate onHide ---
  const [allowClose, setAllowClose] = useState(true);

  useEffect(() => {
    if (visible) {
      setAllowClose(false);
      const timer = setTimeout(() => setAllowClose(true), 2000); // 200ms grace period
      return () => clearTimeout(timer);
    }
  }, [visible]);

  const handleHide = () => {
    if (!allowClose) return; // ignore premature hide
    onHide?.(); // call the parent onHide
  };

  // const ims = () => {
  //   const oc = () => {
  //     console.log('first')
  //   }
  //   return <ItemMenuSquares
  //     onClick={oc}
  //     caption={'Options'}
  //     icon={'options'}
  //     menuItems={content}
  //     imsType={_imsTypes.inline}
  //   />
  // }

  // const fpw = () => <FullPageWrapper
  //   content={content}
  //   handleCancel={onHide}
  //   css={{ container: 'app-dark-mode' }}
  // ></FullPageWrapper >

  const sidebar = () => <Sidebar
    {...styleAndClass}
    animation="overlay"
    direction={direction ?? 'left'}
    icon="labeled"
    visible={visible}
    width={width ?? 'very wide'}
    className={`vsr-container dsb ${cn ?? ''}`}
    onHide={handleHide}
  >
    {/* <div>TEST</div> */}
    {content}
  </Sidebar>

  return visible ? (
    sidebar()
  ) : (
    <div className={styleAndClass?.className}></div >
  );
};

export default DataSidebar;
